"use client";

import { useDateFormatter, type DateFormatterOptions } from "react-aria";

import { TIMEZONE } from "@trip/constants";
import { type DateRange } from "@trip/utils";

export function useDateRangeFormatter(options?: DateFormatterOptions) {
  const formatter = useDateFormatter({
    dateStyle: "long",
    timeZone: TIMEZONE,
    ...options,
  });
  return (dateRange: DateRange) =>
    formatter
      .formatRange(
        dateRange.start.toDate(options?.timeZone ?? TIMEZONE),
        dateRange.end.toDate(options?.timeZone ?? TIMEZONE),
      )
      .replace(" – ", " – ");
}
